export default __webpack_public_path__ + "static/media/jordys-gonzalez-300x300.6895c096.jpg";